import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface InstitutionSettings {
  id: string;
  market_segment: 'power5' | 'fcs' | 'div2' | 'div3' | 'naia' | 'highschool';
  enable_deal_pipeline: boolean;
  enable_contract_versioning: boolean;
  enable_agent_marketplace: boolean;
  enable_brand_marketplace: boolean;
  enable_monetization_hub: boolean;
  enable_conference_partnership: boolean;
  enable_roi_tracking: boolean;
  enable_real_time_alerts: boolean;
  enable_compliance_audit_tool: boolean;
  [key: string]: any;
}

export const useInstitutionSettings = () => {
  const { data: settings, isLoading, refetch } = useQuery({
    queryKey: ["institution-settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("institution_settings" as any)
        .select("*")
        .limit(1)
        .maybeSingle();

      if (error && error.code !== "PGRST116") throw error;
      return data;
    },
  });

  return {
    settings,
    isLoading,
    refetch,
  };
};
